import * as React from "react";
import { Button, Checkbox, Classes, Intent, Radio } from "@focus/focusUI";
import "./GraphSelector.scss";
export class CustomGraphSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.changeSelection = (value) => () => {
            const currentlySelected = this.state.selectedDisplays.find((g) => g === value);
            if (currentlySelected) {
                this.setState({
                    selectedDisplays: this.state.selectedDisplays.filter((g) => g !== value),
                });
            }
            else {
                this.setState({
                    selectedDisplays: this.state.selectedDisplays.concat([value]),
                });
            }
        };
        this.changeSelectionX = (value) => () => {
            const currentlySelected = this.state.selectedAxisX === value;
            if (currentlySelected) {
                this.setState({
                    selectedAxisX: "",
                });
            }
            else {
                this.setState({
                    selectedAxisX: value,
                });
            }
        };
        this.selectAll = () => {
            let displays = [];
            this.props.config.customSelectorFolderList.forEach((selectors) => {
                selectors.selectorList.map((display) => {
                    displays.push(display);
                });
            });
            this.setState({
                selectedDisplays: displays.map((e) => e.id),
            });
        };
        this.unselectAll = () => {
            this.setState({
                selectedDisplays: [],
            });
        };
        this.displayPlot = () => {
            let displays = [];
            this.props.config.customSelectorFolderList.forEach((selectors) => selectors.selectorList.forEach((display) => {
                if (this.state.selectedDisplays.includes(display.id)) {
                    displays = [...displays, display];
                }
            }));
            this.props.onSelect(displays, this.state.selectedAxisX ? this.state.selectedAxisX : "empty");
        };
        this.state = { selectedDisplays: [], selectedAxisX: undefined };
    }
    render() {
        const selectorFolderList = this.props.config.customSelectorFolderList;
        return (React.createElement("div", { className: "focusgrafos-graph_selector" },
            React.createElement("h3", { className: Classes.HEADING }, "Graphs"),
            React.createElement("div", { className: "focusgrafos-graph_controls" },
                this.state.selectedDisplays.length == 0 ? (React.createElement(Button, { minimal: true, text: "Select All", icon: "filter-list", onClick: this.selectAll })) : (React.createElement(Button, { minimal: true, text: "Unselect All", icon: "filter-remove", onClick: this.unselectAll })),
                React.createElement(Button, { intent: Intent.PRIMARY, text: "Display Plot", icon: "timeline-line-chart", onClick: this.displayPlot })),
            React.createElement("div", { className: "focusgrafos-graph_graphs" },
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Values"),
                            React.createElement("th", null, "X"),
                            React.createElement("th", null, "Y")),
                        selectorFolderList.map((selector) => selector.selectorList.map((display) => display.title !== "Template" ? (React.createElement("tr", { key: display.id },
                            React.createElement("td", { className: "graphId" }, display.title),
                            React.createElement("td", null,
                                React.createElement(Radio, { name: "xValue", className: "inputCells", onChange: this.changeSelectionX(display.id) })),
                            React.createElement("td", null,
                                React.createElement(Checkbox, { checked: this.state.selectedDisplays.includes(display.id), key: display.id, onChange: this.changeSelection(display.id), className: "inputCells" })))) : null)))))));
    }
}
//# sourceMappingURL=CustomGraphSelector.js.map